<elcia-dropdown
  [control]="control()"
  [items]="features()"
  [label]="'product.feature' | translate"
  [textField]="'name'"
  [valueField]="'id'"
/>
